export default __webpack_public_path__ + "static/media/Tuesday_04.e62bec43.png";